export default __webpack_public_path__ + "static/media/footer_bg.0c288c69.png";